module.exports = __webpack_public_path__ + "static/media/member_message_01.f2d408af.jpg";